import { render } from "./split-circle.svg?vue&type=template&id=a6ccc8aa?inline"
const script = {}
script.render = render

export default script